const { useEffect, useState } = require('react');

const { useIndexedDB } = require('react-indexed-db-hook');

const { userApi } = require('@store');

const { useOnlineStatusDetector } = require('./useOnlineStatusDetector');

export const useSyncOfflineData = () => {
  const { isOnline } = useOnlineStatusDetector();

  const {
    deleteRecord: deleteActivityRecord,

    getAll: getAllCompletedLessonActivities,
  } = useIndexedDB('completed_lesson_activity');

  const { deleteRecord: deleteLessonRecord, getAll: getAllCompletedLessons } =
    useIndexedDB('completed_lesson');

  const {
    deleteRecord: deleteModuleRecord,

    getAll: getAllCompletedCourseModules,
  } = useIndexedDB('completed_course_module');

  const {
    deleteRecord: deleteTestStepRecord,

    getAll: getAllCompletedTestSteps,
  } = useIndexedDB('completed_test_step');

  const { deleteRecord: deleteTestRecord, getAll: getAllCompletedTests } =
    useIndexedDB('completed_test');

  const [data, setData] = useState(null);

  useEffect(() => {
    const init = async () => {
      const completedCourseModules = await getAllCompletedCourseModules();

      const completedLessons = await getAllCompletedLessons();

      const completedLessonActivities = await getAllCompletedLessonActivities();

      const completedTests = await getAllCompletedTests();

      const completedTestSteps = await getAllCompletedTestSteps();

      const somethingIsNotEmpty =
        completedCourseModules?.length > 0 ||
        completedLessons?.length > 0 ||
        completedLessonActivities?.length > 0 ||
        completedTests?.length > 0 ||
        completedTestSteps?.length > 0;

      if (somethingIsNotEmpty)
        setData({
          completedCourseModules,

          completedLessonActivities,

          completedLessons,

          completedTestSteps,

          completedTests,
        });
    };

    init();
  }, []);

  const cleanTables = () => {
    data.completedLessonActivities.forEach((element) => {
      deleteActivityRecord(element.id);
    });

    data.completedLessons.forEach((element) => {
      deleteLessonRecord(element.id);
    });

    data.completedCourseModules.forEach((element) => {
      deleteModuleRecord(element.id);
    });

    data.completedTestSteps.forEach((element) => {
      deleteTestStepRecord(element.id);
    });

    data.completedTests.forEach((element) => {
      deleteTestRecord(element.id);
    });

    setData(null);
  };

  const [syncProgress] = userApi.useSyncOfflineProgressMutation();

  const syncData = async () => {
    await syncProgress(data);
    cleanTables();
  };

  useEffect(() => {
    if (isOnline && data) {
      syncData(data);
    }
  }, [!isOnline, !data]);
};
